module.exports = require("babel-runtime/core-js/object/assign");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/assign"
// module id = 11
// module chunks = 0